import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";
import VariantBuilderPanelCollapse from "../variants/VariantBuilderPanelCollapse";

const VariantSettingsThemeReviews = (props) => {
  const [contextData] = useContext(VariantContextData);
  let variant = contextData.objects.variant;

  return (
    <React.Fragment>
      <VariantBuilderPanelCollapse name="Reviews" open={false}>
        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-container-width]"
          setting_type="range"
          object_type="variants"
          label="Container Width"
          value={variant.options["reviews-container-width"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-container-width-mobile]"
          setting_type="range"
          object_type="variants"
          label="Container Width"
          value={variant.options["reviews-container-width-mobile"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-container-height]"
          setting_type="range"
          object_type="variants"
          label="Container Height"
          value={variant.options["reviews-container-height"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
          tooltip="Applied as min-height; review card grows taller if content requires it."
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-container-height-mobile]"
          setting_type="range"
          object_type="variants"
          label="Container Height"
          value={variant.options["reviews-container-height-mobile"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
          tooltip="Applied as min-height; review card grows taller if content requires it."
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-content-vertical-spacing]"
          setting_type="range"
          object_type="variants"
          label="Content Vertical Spacing"
          value={variant.options["reviews-content-vertical-spacing"]}
          placeholder="15"
          min={0}
          max={200}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
          tooltip="Gap between each content type inside a review."
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-content-vertical-spacing-mobile]"
          setting_type="range"
          object_type="variants"
          label="Content Vertical Spacing"
          value={variant.options["reviews-content-vertical-spacing-mobile"]}
          placeholder="15"
          min={0}
          max={200}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
          tooltip="Gap between each content type inside a review."
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-arrow-size]"
          setting_type="range"
          object_type="variants"
          label="Arrow Size"
          value={
            variant.options["reviews-arrow-size"]
              ? variant.options["reviews-arrow-size"]
              : undefined
          }
          placeholder="12"
          min={5}
          max={40}
          range_step="1"
          device="desktop"
          allow_empty={true}
          condition={
            (!variant.options["slider-enabled"] ||
              variant.options["slider-enabled"] == "true") &&
            (!variant.options["slider-show-arrows"] ||
              variant.options["slider-show-arrows"] == "true")
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-arrow-size-mobile]"
          setting_type="range"
          object_type="variants"
          label="Arrow Size"
          value={
            variant.options["reviews-arrow-size-mobile"]
              ? variant.options["reviews-arrow-size-mobile"]
              : undefined
          }
          placeholder="12"
          min={5}
          max={40}
          range_step="1"
          device="mobile"
          allow_empty={true}
          condition={
            (!variant.options["slider-enabled"] ||
              variant.options["slider-enabled"] == "true") &&
            (!variant.options["slider-show-arrows"] ||
              variant.options["slider-show-arrows"] == "true")
          }
          show_reset={true}
        />

        <div className="col-xs-12 mt-4 mb-2 text-lg font-semibold text-black dark:text-white">
          Colors with Video Background
        </div>
        <div className="col-xs-12 mb-3 text-base text-slate-500 dark:text-slate-400">
          Applicable when video positioning is set to background. Defaults to white when unset.
        </div>

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Rating Star"
          setting_name="[options][reviews-video-bg-rating-color]"
          setting_type="color_v2"
          value={variant.options["reviews-video-bg-rating-color"]}
          placeholder={
            variant.options["reviews-video-background-text-color"] || "#fff"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Title"
          setting_name="[options][reviews-video-bg-title-color]"
          setting_type="color_v2"
          value={variant.options["reviews-video-bg-title-color"]}
          placeholder={
            variant.options["reviews-video-background-text-color"] || "#fff"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Content"
          setting_name="[options][reviews-video-bg-content-color]"
          setting_type="color_v2"
          value={variant.options["reviews-video-bg-content-color"]}
          placeholder={
            variant.options["reviews-video-background-text-color"] || "#fff"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Customer Name"
          setting_name="[options][reviews-video-bg-customer-name-color]"
          setting_type="color_v2"
          value={variant.options["reviews-video-bg-customer-name-color"]}
          placeholder={
            variant.options["reviews-video-background-text-color"] || "#fff"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Customer Title"
          setting_name="[options][reviews-video-bg-customer-title-color]"
          setting_type="color_v2"
          value={variant.options["reviews-video-bg-customer-title-color"]}
          placeholder={
            variant.options["reviews-video-background-text-color"] || "#fff"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Date"
          setting_name="[options][reviews-video-bg-date-color]"
          setting_type="color_v2"
          value={variant.options["reviews-video-bg-date-color"]}
          placeholder={
            variant.options["reviews-video-background-text-color"] || "#fff"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Source"
          setting_name="[options][reviews-video-bg-source-color]"
          setting_type="color_v2"
          value={variant.options["reviews-video-bg-source-color"]}
          placeholder={
            variant.options["reviews-video-background-text-color"] || "#fff"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Background Color"
          setting_name="[options][reviews-background-color]"
          setting_type="color_v2"
          object_type="variants"
          value={variant.options["reviews-background-color"]}
          placeholder={"#fff"}
          show_reset={true}
          gradient={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Border Style"
          setting_name="[options][reviews-border-style]"
          setting_type="border_style"
          object_type="variants"
          value={
            variant.options["reviews-border-style"]
              ? variant.options["reviews-border-style"]
              : "solid"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-border-width]"
          setting_type="range"
          object_type="variants"
          label="Border Width"
          value={variant.options["reviews-border-width"]}
          placeholder="1"
          min={0}
          max={50}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-border-width-mobile]"
          setting_type="range"
          object_type="variants"
          label="Border Width"
          value={variant.options["reviews-border-width-mobile"]}
          placeholder="1"
          min={0}
          max={50}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
        />

        {variant.options["reviews-border-style"] &&
          variant.options["reviews-border-style"] !==
            "none" && (
            <div
              className="col-xs-12 some-vertical-space setting"
              style={{ marginBottom: "5px" }}
            >
              <div className="row">
                <div className="col-xs-12">
                <div className="mb-[5px] text-xl text-black dark:text-white">
                  Border Width
                </div>

                  {["left", "top", "bottom", "right"].map((side) => {
                    const settingName = `[options][reviews-border-width-${side}]`;
                    return (
                      <VariantBuilderSetting
                        key={settingName}
                        object={variant}
                        setting_name={settingName}
                        setting_type="number"
                        object_type="variants"
                        value={
                          _.isNil(
                            variant.options[
                              `reviews-border-width-${side}`
                            ]
                          ) == false
                            ? variant.options[`reviews-border-width-${side}`]
                            : variant.options["reviews-border-width"]
                            ? variant.options["reviews-border"].replace("px", "")
                            : undefined
                        }
                        placeholder="1px"
                        col="3"
                        note={window.capitalizeFirstLetter(side)}
                        classNames="spacing-inputs"
                        min={0}
                        allow_empty={true}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          )}

        <VariantBuilderSetting
          object={variant}
          label="Border Color"
          setting_name="[options][reviews-border-color]"
          setting_type="color_v2"
          object_type="variants"
          placeholder="#000"
          value={
            variant.options["reviews-border-color"]
              ? variant.options["reviews-border-color"]
              : undefined
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Border Rounding"
          setting_name="[options][reviews-border-rounding]"
          setting_type="border_radius"
          object_type="variants"
          value={
            variant.options["reviews-border-rounding"]
              ? variant.options["reviews-border-rounding"]
              : "cf-not-rounded"
          }
          condition={
            variant.options["reviews-border-style"] !==
            "none"
          }
          valueMappings={{
            none: "cf-not-rounded",
            some: "cf-slightly-rounded",
            full: "cf-fully-rounded",
            custom: "custom",
          }}
        />

        <div className="col-xs-12">
          {["top-left", "top-right", "bottom-right", "bottom-left"].map(
            (side) => {
              const settingName = `[options][reviews-border-rounding-${side}]`;
              return (
                <VariantBuilderSetting
                  key={settingName}
                  object={variant}
                  setting_name={settingName}
                  setting_type="number"
                  object_type="variants"
                  value={
                    _.isNil(
                      variant.options[`reviews-border-rounding-${side}`]
                    ) == false
                      ? variant.options[
                          `reviews-border-rounding-${side}`
                        ]
                      : undefined
                  }
                  condition={
                    variant.options[
                      "reviews-border-rounding"
                    ] == "custom"
                  }
                  min={0}
                  note={capitalizeFirstLetter(side).replace("-", " ")}
                  col="3"
                  placeholder="0px"
                  classNames="spacing-inputs"
                />
              );
            }
          )}
        </div>

        <VariantBuilderSetting
          object={variant}
          label="Rating Star Color"
          setting_name="[options][reviews-rating-star-color]"
          setting_type="color_v2"
          object_type="variants"
          value={
            variant.options["reviews-rating-star-color"]
              ? variant.options["reviews-rating-star-color"]
              : undefined
          }
          placeholder={"#EFAB40"}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Rating Star Size"
          setting_name="[options][reviews-rating-star-size]"
          setting_type="range"
          object_type="variants"
          value={
            variant.options["reviews-rating-star-size"]
              ? variant.options["reviews-rating-star-size"]
              : undefined
          }
          placeholder={"14"}
          allow_empty={true}
          min={0}
          max={100}
          range_step={1}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Rating Star Size"
          setting_name="[options][reviews-rating-star-size-mobile]"
          setting_type="range"
          object_type="variants"
          value={
            variant.options["reviews-rating-star-size-mobile"]
              ? variant.options["reviews-rating-star-size-mobile"]
              : undefined
          }
          placeholder={"14"}
          allow_empty={true}
          min={0}
          max={100}
          range_step={1}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-customer-profile-avatar-width]"
          setting_type="range"
          object_type="variants"
          label="Customer Avatar Image Width"
          value={variant.options["reviews-customer-profile-avatar-width"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-customer-profile-avatar-width-mobile]"
          setting_type="range"
          object_type="variants"
          label="Customer Avatar Image Width"
          value={variant.options["reviews-customer-profile-avatar-width-mobile"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-customer-profile-avatar-height]"
          setting_type="range"
          object_type="variants"
          label="Customer Avatar Image Height"
          value={variant.options["reviews-customer-profile-avatar-height"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-customer-profile-avatar-height-mobile]"
          setting_type="range"
          object_type="variants"
          label="Customer Avatar Image Height"
          value={variant.options["reviews-customer-profile-avatar-height-mobile"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Customer Avatar Image Radius"
          setting_name="[options][reviews-customer-profile-avatar-radius]"
          setting_type="border_radius"
          valueMappings={{
            none: "cf-not-rounded",
            some: "cf-slightly-rounded",
            full: "cf-fully-rounded",
            custom: "custom",
          }}
          object_type="variants"
          value={variant.options["reviews-customer-profile-avatar-radius"]}
          show_reset={true}
        />

        {variant.options["reviews-customer-profile-avatar-radius"] == "custom" && (
          <div className="col-xs-12">
            {["top-left", "top-right", "bottom-right", "bottom-left"].map(
              (side) => {
                const settingName = `[options][reviews-customer-profile-avatar-radius-${side}]`;
                return (
                  <VariantBuilderSetting
                    key={settingName}
                    object={variant}
                    setting_name={settingName}
                    setting_type="number"
                    object_type="variants"
                    value={
                      _.isNil(
                        variant.options[
                          `reviews-customer-profile-avatar-radius-${side}`
                        ]
                      ) == false
                        ? variant.options[
                            `reviews-customer-profile-avatar-radius-${side}`
                          ]
                        : undefined
                    }
                    min={0}
                    note={capitalizeFirstLetter(side).replace("-", " ")}
                    col="3"
                    placeholder={"0px"}
                    classNames="spacing-inputs"
                  />
                );
              }
            )}
          </div>
        )}

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-brand-logo-width]"
          setting_type="range"
          object_type="variants"
          label="Brand Logo Image Width"
          value={variant.options["brand-logo-width"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-brand-logo-width-mobile]"
          setting_type="range"
          object_type="variants"
          label="Brand Logo Image Width"
          value={variant.options["brand-logo-width-mobile"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-brand-logo-height]"
          setting_type="range"
          object_type="variants"
          label="Brand Logo Image Height"
          value={variant.options["brand-logo-height"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-brand-logo-height-mobile]"
          setting_type="range"
          object_type="variants"
          label="Brand Logo Image Height"
          value={variant.options["brand-logo-height-mobile"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Customer Avatar Image Radius"
          setting_name="[options][reviews-brand-logo-radius]"
          setting_type="border_radius"
          valueMappings={{
            none: "cf-not-rounded",
            some: "cf-slightly-rounded",
            full: "cf-fully-rounded",
            custom: "custom",
          }}
          object_type="variants"
          value={variant.options["reviews-brand-logo-radius"]}
          show_reset={true}
        />

        {variant.options["brand-logo-radius"] == "custom" && (
          <div className="col-xs-12">
            {["top-left", "top-right", "bottom-right", "bottom-left"].map(
              (side) => {
                const settingName = `[options][reviews-brand-logo-radius-${side}]`;
                return (
                  <VariantBuilderSetting
                    key={settingName}
                    object={variant}
                    setting_name={settingName}
                    setting_type="number"
                    object_type="variants"
                    value={
                      _.isNil(
                        variant.options[
                          `reviews-brand-logo-radius-${side}`
                        ]
                      ) == false
                        ? variant.options[
                            `reviews-brand-logo-radius-${side}`
                          ]
                        : undefined
                    }
                    min={0}
                    note={capitalizeFirstLetter(side).replace("-", " ")}
                    col="3"
                    placeholder={"0px"}
                    classNames="spacing-inputs"
                  />
                );
              }
            )}
          </div>
        )}

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-video-width]"
          setting_type="range"
          object_type="variants"
          label="Video Width"
          value={variant.options["reviews-video-width"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-video-width-mobile]"
          setting_type="range"
          object_type="variants"
          label="Video Width"
          value={variant.options["reviews-video-width-mobile"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-video-height]"
          setting_type="range"
          object_type="variants"
          label="Video Height"
          value={variant.options["reviews-video-height"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][reviews-video-height-mobile]"
          setting_type="range"
          object_type="variants"
          label="Video Height"
          value={variant.options["reviews-video-height-mobile"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label={`Reviews Source Font`}
          setting_name={`[options][reviews-source-font-family]`}
          setting_type="select"
          value={variant.options[`reviews-source-font-family`]}
          placeholder={variant.options[`p-font-family`]}
          option_groups={["System fonts", "Google fonts"]}
          options={[
            { value: "", text: "Default" },
            ...window.builder_fonts_dropdown,
          ]}
          col="8"
          callback={(new_value, old_value) => {
            ctas.builder.fonts.load_font_family(new_value);
          }}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          setting_name={`[options][reviews-source-font-weight]`}
          setting_type="font_weight"
          label="Weight"
          value={variant.options[`reviews-source-font-weight`]}
          placeholder={variant.options[`p-font-weight`]}
          col="4"
          classNames="no-padding-left"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label={`Reviews Source Font size`}
          setting_name={`[options][reviews-source-font-size]`}
          setting_type="range"
          value={variant.options[`reviews-source-font-size`]}
          placeholder={variant.options[`p-font-size`] || "14"}
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label={`Reviews Source Font size`}
          setting_name={`[options][reviews-source-font-size-mobile]`}
          setting_type="range"
          value={variant.options[`reviews-source-font-size-mobile`]}
          placeholder={
            variant.options[`p-font-size-mobile`] ||
            variant.options[`p-font-size`]
              ? variant.options[`p-font-size`]
              : "14"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label={`Reviews Source Font line height`}
          setting_name={`[options][reviews-source-font-line-height]`}
          setting_type="range"
          value={variant.options[`reviews-source-font-line-height`]}
          placeholder={
            variant.options[`p-font-line-height`]
              ? variant.options[`p-font-line-height`]
              : "20"
          }
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label={`Reviews Source Font line height`}
          setting_name={`[options][reviews-source-font-line-height-mobile]`}
          setting_type="range"
          value={variant.options[`reviews-source-font-line-height-mobile`]}
          placeholder={
            variant.options[`p-font-line-height-mobile`]
              ? variant.options[`p-font-line-height-mobile`]
              : variant.options[`p-font-line-height`]
              ? variant.options[`p-font-line-height`]
              : "20"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label={`Reviews Source Font color`}
          setting_name={`[options][reviews-source-font-color]`}
          setting_type="color_v2"
          value={variant.options[`reviews-source-font-color`]}
          placeholder={
            variant.options[`p-font-color`]
              ? variant.options[`p-font-color`]
              : "#696969"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Title Font"
          setting_name="[options][reviews-title-font-family]"
          setting_type="select"
          value={variant.options["reviews-title-font-family"]}
          placeholder={variant.options["h3-font-family"]}
          option_groups={["System fonts", "Google fonts"]}
          options={[
            { value: "", text: "Default" },
            ...window.builder_fonts_dropdown,
          ]}
          col="8"
          callback={(new_value, old_value) => {
            ctas.builder.fonts.load_font_family(new_value);
          }}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          setting_name="[options][reviews-title-font-weight]"
          setting_type="font_weight"
          label="Weight"
          value={variant.options["reviews-title-font-weight"]}
          placeholder={variant.options["h3-font-weight"] || "700"}
          col="4"
          classNames="no-padding-left"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Title Font size"
          setting_name="[options][reviews-title-font-size]"
          setting_type="range"
          value={variant.options["reviews-title-font-size"]}
          placeholder={variant.options["h3-font-size"] || "16"}
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Title Font size"
          setting_name="[options][reviews-title-font-size-mobile]"
          setting_type="range"
          value={variant.options["reviews-title-font-size-mobile"]}
          placeholder={
            variant.options["h3-font-size-mobile"] ||
            variant.options["h3-font-size"] ||
            "16"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Title Font line height"
          setting_name="[options][reviews-title-font-line-height]"
          setting_type="range"
          value={variant.options["reviews-title-font-line-height"]}
          placeholder={variant.options["h3-font-line-height"] || "20"}
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Title Font line height"
          setting_name="[options][reviews-title-font-line-height-mobile]"
          setting_type="range"
          value={variant.options["reviews-title-font-line-height-mobile"]}
          placeholder={
            variant.options["h3-font-line-height-mobile"] ||
            variant.options["h3-font-line-height"] ||
            "20"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Title Font color"
          setting_name="[options][reviews-title-font-color]"
          setting_type="color_v2"
          value={variant.options["reviews-title-font-color"]}
          placeholder={variant.options["h3-font-color"] || "#000"}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Content Font"
          setting_name="[options][reviews-content-font-family]"
          setting_type="select"
          value={variant.options["reviews-content-font-family"]}
          placeholder={variant.options["p-font-family"]}
          option_groups={["System fonts", "Google fonts"]}
          options={[
            { value: "", text: "Default" },
            ...window.builder_fonts_dropdown,
          ]}
          col="8"
          callback={(new_value, old_value) => {
            ctas.builder.fonts.load_font_family(new_value);
          }}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          setting_name="[options][reviews-content-font-weight]"
          setting_type="font_weight"
          label="Weight"
          value={variant.options["reviews-content-font-weight"]}
          placeholder={variant.options["p-font-weight"]}
          col="4"
          classNames="no-padding-left"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Content Font size"
          setting_name="[options][reviews-content-font-size]"
          setting_type="range"
          value={variant.options["reviews-content-font-size"]}
          placeholder={variant.options["p-font-size"] || "14"}
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Content Font size"
          setting_name="[options][reviews-content-font-size-mobile]"
          setting_type="range"
          value={variant.options["reviews-content-font-size-mobile"]}
          placeholder={
            variant.options["p-font-size-mobile"] ||
            variant.options["p-font-size"] ||
            "14"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Content Font line height"
          setting_name="[options][reviews-content-font-line-height]"
          setting_type="range"
          value={variant.options["reviews-content-font-line-height"]}
          placeholder={variant.options["p-font-line-height"] || "25"}
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Content Font line height"
          setting_name="[options][reviews-content-font-line-height-mobile]"
          setting_type="range"
          value={variant.options["reviews-content-font-line-height-mobile"]}
          placeholder={
            variant.options["p-font-line-height-mobile"] ||
            variant.options["p-font-line-height"] ||
            "25"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Content Font color"
          setting_name="[options][reviews-content-font-color]"
          setting_type="color_v2"
          value={variant.options["reviews-content-font-color"]}
          placeholder={variant.options["p-font-color"] || "#696969"}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Customer Name Font"
          setting_name="[options][reviews-customer-profile-name-font-family]"
          setting_type="select"
          value={variant.options["reviews-customer-profile-name-font-family"]}
          placeholder={variant.options["p-font-family"]}
          option_groups={["System fonts", "Google fonts"]}
          options={[
            { value: "", text: "Default" },
            ...window.builder_fonts_dropdown,
          ]}
          col="8"
          callback={(new_value, old_value) => {
            ctas.builder.fonts.load_font_family(new_value);
          }}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          setting_name="[options][reviews-customer-profile-name-font-weight]"
          setting_type="font_weight"
          label="Weight"
          value={variant.options["reviews-customer-profile-name-font-weight"]}
          placeholder={variant.options["p-font-weight"]}
          col="4"
          classNames="no-padding-left"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Customer Name Font size"
          setting_name="[options][reviews-customer-profile-name-font-size]"
          setting_type="range"
          value={variant.options["reviews-customer-profile-name-font-size"]}
          placeholder={variant.options["p-font-size"] || "14"}
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Customer Name Font size"
          setting_name="[options][reviews-customer-profile-name-font-size-mobile]"
          setting_type="range"
          value={variant.options["reviews-customer-profile-name-font-size-mobile"]}
          placeholder={
            variant.options["p-font-size-mobile"] ||
            variant.options["p-font-size"] ||
            "14"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Customer Name Font line height"
          setting_name="[options][reviews-customer-profile-name-font-line-height]"
          setting_type="range"
          value={variant.options["reviews-customer-profile-name-font-line-height"]}
          placeholder={variant.options["p-font-line-height"] || "20"}
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Customer Name Font line height"
          setting_name="[options][reviews-customer-profile-name-font-line-height-mobile]"
          setting_type="range"
          value={
            variant.options[
              "reviews-customer-profile-name-font-line-height-mobile"
            ]
          }
          placeholder={
            variant.options["p-font-line-height-mobile"] ||
            variant.options["p-font-line-height"] ||
            "20"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Customer Name Font color"
          setting_name="[options][reviews-customer-profile-name-font-color]"
          setting_type="color_v2"
          value={variant.options["reviews-customer-profile-name-font-color"]}
          placeholder={variant.options["p-font-color"] || "#000"}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Customer Title Font"
          setting_name="[options][reviews-customer-profile-title-font-family]"
          setting_type="select"
          value={variant.options["reviews-customer-profile-title-font-family"]}
          placeholder={variant.options["p-font-family"]}
          option_groups={["System fonts", "Google fonts"]}
          options={[
            { value: "", text: "Default" },
            ...window.builder_fonts_dropdown,
          ]}
          col="8"
          callback={(new_value, old_value) => {
            ctas.builder.fonts.load_font_family(new_value);
          }}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          setting_name="[options][reviews-customer-profile-title-font-weight]"
          setting_type="font_weight"
          label="Weight"
          value={variant.options["reviews-customer-profile-title-font-weight"]}
          placeholder={variant.options["p-font-weight"]}
          col="4"
          classNames="no-padding-left"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Customer Title Font size"
          setting_name="[options][reviews-customer-profile-title-font-size]"
          setting_type="range"
          value={variant.options["reviews-customer-profile-title-font-size"]}
          placeholder={variant.options["p-font-size"] || "12"}
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Customer Title Font size"
          setting_name="[options][reviews-customer-profile-title-font-size-mobile]"
          setting_type="range"
          value={
            variant.options["reviews-customer-profile-title-font-size-mobile"]
          }
          placeholder={
            variant.options["p-font-size-mobile"] ||
            variant.options["p-font-size"] ||
            "12"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Customer Title Font line height"
          setting_name="[options][reviews-customer-profile-title-font-line-height]"
          setting_type="range"
          value={
            variant.options["reviews-customer-profile-title-font-line-height"]
          }
          placeholder={variant.options["p-font-line-height"] || "20"}
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Customer Title Font line height"
          setting_name="[options][reviews-customer-profile-title-font-line-height-mobile]"
          setting_type="range"
          value={
            variant.options[
              "reviews-customer-profile-title-font-line-height-mobile"
            ]
          }
          placeholder={
            variant.options["p-font-line-height-mobile"] ||
            variant.options["p-font-line-height"] ||
            "20"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Customer Title Font color"
          setting_name="[options][reviews-customer-profile-title-font-color]"
          setting_type="color_v2"
          value={variant.options["reviews-customer-profile-title-font-color"]}
          placeholder={variant.options["p-font-color"] || "#696969"}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Date Format"
          setting_name="[options][reviews-date-format]"
          setting_type="select"
          value={variant.options["reviews-date-format"]}
          placeholder="YYYY-MM-DD"
          options={[
            { value: "", text: "Default (YYYY-MM-DD)" },
            { value: "YYYY/MM/DD", text: "2024/06/27 (YYYY/MM/DD)" },
            { value: "MM/DD/YYYY", text: "06/27/2024 (MM/DD/YYYY)" },
            { value: "DD/MM/YYYY", text: "27/06/2024 (DD/MM/YYYY)" },
            { value: "MMMM DD, YYYY", text: "June 27, 2024 (MMMM DD, YYYY)" },
            { value: "DD MMMM YYYY", text: "27 June 2024 (DD MMMM YYYY)" },
          ]}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Date Font"
          setting_name="[options][reviews-date-font-family]"
          setting_type="select"
          value={variant.options["reviews-date-font-family"]}
          placeholder={variant.options["p-font-family"]}
          option_groups={["System fonts", "Google fonts"]}
          options={[
            { value: "", text: "Default" },
            ...window.builder_fonts_dropdown,
          ]}
          col="8"
          callback={(new_value, old_value) => {
            ctas.builder.fonts.load_font_family(new_value);
          }}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          setting_name="[options][reviews-date-font-weight]"
          setting_type="font_weight"
          label="Weight"
          value={variant.options["reviews-date-font-weight"]}
          placeholder={variant.options["p-font-weight"]}
          col="4"
          classNames="no-padding-left"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Date Font size"
          setting_name="[options][reviews-date-font-size]"
          setting_type="range"
          value={variant.options["reviews-date-font-size"]}
          placeholder={variant.options["p-font-size"] || "14"}
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Date Font size"
          setting_name="[options][reviews-date-font-size-mobile]"
          setting_type="range"
          value={variant.options["reviews-date-font-size-mobile"]}
          placeholder={
            variant.options["p-font-size-mobile"] ||
            variant.options["p-font-size"] ||
            "14"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Date Font line height"
          setting_name="[options][reviews-date-font-line-height]"
          setting_type="range"
          value={variant.options["reviews-date-font-line-height"]}
          placeholder={variant.options["p-font-line-height"] || "20"}
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Date Font line height"
          setting_name="[options][reviews-date-font-line-height-mobile]"
          setting_type="range"
          value={variant.options["reviews-date-font-line-height-mobile"]}
          placeholder={
            variant.options["p-font-line-height-mobile"] ||
            variant.options["p-font-line-height"] ||
            "20"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Date Font color"
          setting_name="[options][reviews-date-font-color]"
          setting_type="color_v2"
          value={variant.options["reviews-date-font-color"]}
          placeholder={variant.options["p-font-color"] || "#696969"}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Video Overlay Color"
          setting_name="[options][reviews-video-overlay-color]"
          setting_type="color_v2"
          tooltip="Applicable when video positioning is set to background"
          value={
            variant.options["reviews-video-overlay-color"]
              ? variant.options["reviews-video-overlay-color"]
              : undefined
          }
          placeholder={"#000"}
          show_reset={true}
          gradient={true}
        />
      </VariantBuilderPanelCollapse>
    </React.Fragment>
  );
};

export default VariantSettingsThemeReviews;
